// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-ui-secret-reveal {
  display: inline-flex;
  gap: 12px;
}
.work-ui-secret-reveal .value-container {
  cursor: zoom-in;
}
.work-ui-secret-reveal .value {
  transition: filter 0.3s ease, opacity 0.3s ease;
  filter: blur(5px);
  opacity: 0.6;
}
.work-ui-secret-reveal .value.revealed {
  filter: blur(0);
  opacity: 1;
  cursor: zoom-out;
}`, "",{"version":3,"sources":["webpack://./src/app/components/secret-reveal/secret-reveal.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,SAAA;AACF;AACE;EACE,eAAA;AACJ;AAEE;EACE,+CAAA;EACA,iBAAA;EACA,YAAA;AAAJ;AAEI;EACE,eAAA;EACA,UAAA;EACA,gBAAA;AAAN","sourcesContent":[".work-ui-secret-reveal {\n  display: inline-flex;\n  gap: 12px;\n\n  .value-container {\n    cursor: zoom-in;\n  }\n\n  .value {\n    transition: filter 0.3s ease, opacity 0.3s ease;\n    filter: blur(5px);\n    opacity: 0.6;\n\n    &.revealed {\n      filter: blur(0);\n      opacity: 1;\n      cursor: zoom-out;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
